<div class="page-container" [class.loading]="loading">
    <app-header
        [title]="'payroll.taxReturns.submit.' + returnType + '.title' | translate: { year: summary.year }"
        [badgeOptions]="summary.stateBadge"
    >
        <app-back-button
            backButtonText="payroll.taxReturns.submit.back"
            backRoute="../../"
            [backButtonTextParams]="{ year: summary.year }"
        />
    </app-header>

    @if (!shouldShowFinishScreen) {
        @if (this.summary.isT4Summary()) {
            <ui-banner variant="warning">
                {{ 'payroll.taxReturns.submit.T4.warning' | translate }}
            </ui-banner>
        }

        @if (!isManualSubmissionInProgress) {
            <ui-button type="outline" (click)="downloadTaxReturnPreview()">{{
                'payroll.taxReturns.downloadPreview' | translate
            }}</ui-button>
        }

        <div class="confirmations">
            @for (confirmation of confirmations; track $index) {
                <mat-checkbox
                    [ngModel]="confirmations[$index]()"
                    (ngModelChange)="confirmations[$index].set($event)"
                    [disabled]="summary.isSubmitted"
                    ><span
                        class="font-medium"
                        translate="payroll.taxReturns.submit.{{ returnType }}.confirmations.{{ $index }}"
                    ></span
                ></mat-checkbox>
            }
        </div>
        @if (isSubmissionCardVisible()) {
            @if (isManualSubmissionInProgress) {
                <ui-card>
                    <app-segment-header
                        title="payroll.taxReturns.submit.{{ returnType }}.selfSubmit.inProgress.title"
                    ></app-segment-header>

                    <div
                        [innerHTML]="
                            'payroll.taxReturns.submit.' + returnType + '.selfSubmit.inProgress.disclaimer'
                                | translate
                                | sanitizeHtml
                        "
                    ></div>

                    <ng-container [ngTemplateOutlet]="selfSubmitSteps"></ng-container>

                    <div class="margin-top-3">
                        <ui-button type="link" (click)="downloadTaxReturnPreview()">{{
                            'payroll.taxReturns.downloadPreview' | translate
                        }}</ui-button>
                        <ui-button type="primary" (click)="downloadSelfSubmitDocuments()">{{
                            'payroll.taxReturns.submit.' + returnType + '.selfSubmit.inProgress.downloadFile'
                                | translate
                        }}</ui-button>
                    </div>

                    <hr class="margin-y-3" />

                    @if (returnType === 'T4') {
                        <mat-form-field>
                            <mat-label translate="payroll.taxReturns.submit.T4.confirmationNumber"></mat-label>
                            <input
                                matInput
                                type="text"
                                name="craConfirmationNumber"
                                [(ngModel)]="craConfirmationNumber"
                                required
                            />
                            <mat-hint translate="payroll.taxReturns.submit.T4.selfSubmit.inProgress.hint"></mat-hint>
                        </mat-form-field>
                    }
                    @if (returnType === 'RL1') {
                        <div class="flex col">
                            <mat-label
                                translate="payroll.taxReturns.submit.RL1.selfSubmit.inProgress.confirmation.label"
                            ></mat-label>
                            <mat-checkbox
                                class="margin-top-2"
                                name="rqManualConfirmation"
                                required
                                [(ngModel)]="rqManualConfirmation"
                            >
                                {{
                                    'payroll.taxReturns.submit.RL1.selfSubmit.inProgress.confirmation.control'
                                        | translate
                                }}
                            </mat-checkbox>
                        </div>
                    }

                    <div class="margin-top-4">
                        <ui-button
                            type="primary"
                            [disabled]="!(craConfirmationNumber() || rqManualConfirmation())"
                            (click)="submitConfirmation()"
                        >
                            <span
                                translate="payroll.taxReturns.submit.{{
                                    returnType
                                }}.selfSubmit.inProgress.confirmation.submit"
                            ></span>
                        </ui-button>
                    </div>
                </ui-card>
            } @else {
                <ui-card>
                    <app-segment-header title="payroll.taxReturns.submit.{{ returnType }}.submitToAgency" />

                    <p
                        class="margin-bottom-4"
                        [class.disabled]="manualSubmission"
                        translate="payroll.taxReturns.submit.{{ returnType }}.disclaimer"
                    ></p>

                    <ui-button
                        type="primary"
                        [disabled]="manualSubmission"
                        (click)="onSubmit({ isManualSubmit: false })"
                    >
                        <span translate="payroll.taxReturns.submit.{{ returnType }}.submitToAgency"></span>
                    </ui-button>

                    <hr class="margin-y-4" />

                    <mat-checkbox [(ngModel)]="manualSubmission">
                        <span translate="payroll.taxReturns.submit.{{ returnType }}.selfSubmit.confirmation"></span>
                    </mat-checkbox>

                    @if (manualSubmission) {
                        <div
                            class="margin-top-4"
                            [innerHTML]="
                                'payroll.taxReturns.submit.' + returnType + '.selfSubmit.disclaimer'
                                    | translate
                                    | sanitizeHtml
                            "
                        ></div>

                        <ng-container [ngTemplateOutlet]="selfSubmitSteps"></ng-container>

                        <ui-button type="primary" class="margin-top-2" (click)="onSubmit({ isManualSubmit: true })">{{
                            'payroll.taxReturns.submit.confirmAndProceed' | translate
                        }}</ui-button>
                    }
                </ui-card>
            }
        }
    } @else {
        <div class="submitted-return">
            <ui-card>
                <p
                    class="margin-bottom-4"
                    translate="payroll.taxReturns.submit.{{ returnType }}.submitted.{{
                        !!summary.completedAt ? 'complete' : 'processing'
                    }}"
                ></p>

                <h3 class="margin-bottom-1">{{ 'payroll.taxReturns.submit.submitDate' | translate }}</h3>
                <p>{{ summary.submittedAt | appDate: 'longDate' }}</p>

                <h3 class="margin-bottom-1">{{ 'payroll.taxReturns.submit.completeDate' | translate }}</h3>
                <p>{{ (summary.completedAt | appDate: 'longDate') || '-' }}</p>

                @if (!summary.isRL1Summary() || !summary.hasConfirmedManualSubmission) {
                    <h3
                        class="margin-bottom-1"
                        translate="payroll.taxReturns.submit.{{ returnType }}.confirmationNumber"
                    ></h3>
                    <p>
                        {{
                            (summary.isRL1Summary() ? summary.rqConfirmationNumber : t619?.craConfirmationNumber) || '-'
                        }}
                    </p>
                }

                @if (!summary.canSendEmails) {
                    <ui-tip class="flex margin-y-2">{{ 'payroll.taxForms.RL1.cannotSend' | translate }}</ui-tip>
                }

                <div class="flex wrap margin-top-4">
                    <ui-button type="outline" (click)="downloadTaxPackage()">{{
                        'payroll.taxReturns.downloadTaxPackage' | translate
                    }}</ui-button>
                    <ui-button type="outline" (click)="sendBulkEmails()" [disabled]="!summary.canSendEmails">{{
                        'payroll.taxForms.' + returnType + '.send' | translate
                    }}</ui-button>
                </div>
            </ui-card>

            @if (payrollEnabled) {
                <ui-card>
                    <h3>{{ 'payroll.taxReturns.submit.contact.title' | translate }}</h3>
                    <p>
                        @for (content of 'payroll.taxReturns.submit.contact.description' | translate; track $index) {
                            @if (content === 'LINK_PLACEHOLDER') {
                                <a routerLink="/payroll/settings">{{
                                    'payroll.taxReturns.submit.contact.linkText' | translate
                                }}</a>
                            } @else {
                                {{ content }}
                            }
                        }
                    </p>
                    <div class="contact-info">
                        <div>{{ 'payroll.taxReturns.submit.contact.fields.firstName' | translate }}</div>
                        <div>{{ settings()?.taxFormContactFirstName }}</div>
                        <div>{{ 'payroll.taxReturns.submit.contact.fields.lastName' | translate }}</div>
                        <div>{{ settings()?.taxFormContactLastName }}</div>
                        <div>{{ 'payroll.taxReturns.submit.contact.fields.areaCode' | translate }}</div>
                        <div>{{ settings()?.taxFormContactAreaCode }}</div>
                        <div>{{ 'payroll.taxReturns.submit.contact.fields.phoneNumber' | translate }}</div>
                        <div>{{ settings()?.taxFormContactPhoneNumber }}</div>
                        <div>{{ 'payroll.taxReturns.submit.contact.fields.extension' | translate }}</div>
                        <div>{{ settings()?.taxFormContactPhoneExtensionNumber }}</div>
                        <div>{{ 'payroll.taxReturns.submit.contact.fields.email' | translate }}</div>
                        <div>{{ settings()?.taxFormContactEmail }}</div>
                    </div>
                </ui-card>
            } @else {
                <div>
                    <img class="w-100" alt="" src="/assets/illustrations/chair-money-plant.png" />
                </div>
            }
        </div>
    }
</div>

<ng-template #selfSubmitSteps>
    <h3 translate="payroll.taxReturns.submit.{{ returnType }}.selfSubmit.stepsTitle"></h3>
    <ol>
        @for (step of 'payroll.taxReturns.submit.' + returnType + '.selfSubmit.steps' | translate; track $index) {
            <li [innerHTML]="step"></li>
        }
    </ol>
</ng-template>

<ui-confirmation-dialog
    #autoSubmitModal
    header="payroll.taxReturns.submit.{{ returnType }}.autoSubmit.dialog.title"
    [primaryButtonLabel]="'payroll.taxReturns.submit.confirmAndSubmit'"
    [secondaryButtonLabel]="'cancel'"
>
    @for (
        description of 'payroll.taxReturns.submit.' + returnType + '.autoSubmit.dialog.description' | translate;
        track $index
    ) {
        <div [class.margin-top-2]="$index > 0">{{ description }}</div>
    }
</ui-confirmation-dialog>

<ui-confirmation-dialog
    #manualSubmitModal
    header="payroll.taxReturns.submit.{{ returnType }}.selfSubmit.dialog.title"
    [primaryButtonLabel]="'payroll.taxReturns.submit.confirmAndProceed'"
    [secondaryButtonLabel]="'cancel'"
>
    @for (
        description of 'payroll.taxReturns.submit.' + returnType + '.selfSubmit.dialog.description' | translate;
        track $index
    ) {
        <div [class.margin-top-2]="$index > 0">{{ description }}</div>
    }
</ui-confirmation-dialog>

<app-tax-form-consent-dialog [packageTypeToBeEmailed]="returnType" />
